<template>
  <div class="login">
    <!-- 放logo的地方 -->
    <div class="login-logo">
      <div class="logo-img">
        <img src="./assets/Group.png" alt="" />
        <p class="logo-title">{{ $t("easyCareer") }}</p>
        <div class="logo-title-intro">
          <p>{{ $t("specializedCare") }}</p>
          <p>{{ $t("hiringForeigners") }}</p>
          <p>{{ $t("conciseSystem") }}</p>
          <p>{{ $t("lookWait") }}</p>
        </div>
      </div>
    </div>
    <!-- 登录的操作部分 -->
    <div class="login-main">
      <div class="register">
        <div class="box-top">
          <div class="top-icon" @click="goToIndex">
            <img src="./assets/Arrow_Right_LG.png" alt="" />
          </div>
        </div>
        <div class="box-bottom">
          <div class="bottom-box-title">
            <p class="welcom">Welcome!</p>
            <p class="ja-welcom">
              <span>{{ $t("newRegistration") }}</span>
              <el-dropdown class="welcom-dropdown" @command="handleCommand">
                <span class="el-dropdown-link">
                  {{ lang }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="0">{{
                    $t("chinese")
                  }}</el-dropdown-item>
                  <el-dropdown-item command="1">{{
                    $t("japanese")
                  }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </p>
          </div>
          <!-- 表单部分 -->
          <div class="box-form">
            <!-- 用户名input -->
            <div class="emil-input">
              <p class="emil-input-title">{{ $t("name") }}</p>
              <div class="emil-input-css">
                <img src="./assets/User_01.svg" alt="" class="emil-icon" />
                <input
                  type="text"
                  name=""
                  id="userName"
                  v-model="userName"
                  class="emil-input-css-main"
                  @blur="registerData(4)"
                />
                <span v-if="userNameShow" class="emil-true-css">{{
                  $t("userNameRules")
                }}</span>
              </div>
            </div>
            <!-- 邮箱input -->
            <div class="emil-input">
              <p class="emil-input-title">{{ $t("emil") }}</p>
              <div class="emil-input-css">
                <img src="./assets/Vector (1).png" alt="" class="emil-icon" />
                <input
                  type="text"
                  name=""
                  id="emilData"
                  class="emil-input-css-main"
                  v-model="emilData"
                  @blur="registerData(1)"
                />
              </div>
              <span v-if="emilShow" class="emil-true-css">{{
                $t("emilError")
              }}</span>
            </div>
            <!-- 密码input -->
            <div class="emil-input">
              <p class="emil-input-title">{{ $t("password") }}</p>
              <div class="emil-input-css">
                <img src="./assets/Vector.png" alt="" class="emil-icon" />
                <input
                  type="password"
                  id="passWordData"
                  class="emil-input-css-main"
                  v-model="passWordData"
                  @blur="registerData(2)"
                />
              </div>
              <span v-if="passWordShow" class="emil-true-css">{{
                $t("passwordRules")
              }}</span>
            </div>
            <!-- 确认密码input -->
            <div class="emil-input">
              <p class="emil-input-title">{{ $t("confirmPassword") }}</p>
              <div class="emil-input-css">
                <img src="./assets/Vector.png" alt="" class="emil-icon" />
                <input
                  type="password"
                  name=""
                  id="insurePassWordData"
                  class="emil-input-css-main"
                  v-model="insurePassWordData"
                  @blur="registerData(3)"
                />
              </div>
              <span v-if="insurePassWordShow" class="emil-true-css">{{
                $t("twoPassword")
              }}</span>
            </div>
          </div>
          <p>{{ $t("yourRole") }}</p>
          <!-- 机构选择 -->
          <div>
            <el-button
              class="two-button"
              :class="{ typeActive: type === 1 }"
              @click="checkoutType(1)"
              >{{ $t("medicalInstitution") }}</el-button
            >
            <el-button
              class="two-button button-margin"
              :class="{ typeActive: type === 2 }"
              @click="checkoutType(2)"
              >{{ $t("educationalInstitution") }}</el-button
            >
          </div>
          <!-- 规则同意 -->
          <p class="agree">
            <span class="agree-css" @click="agree">{{ $t("useRules") }}</span
            >{{ $t("agreeToUse") }}
          </p>
          <!-- 确定按钮 -->
          <div class="insure">
            <button class="insure-button" @click="toRegister(type)">
              {{ $t("toRegister") }}
            </button>
          </div>
          <!-- 规则同意 -->
          <p class="agree agree1">
            {{ $t("alreadyRegistered")
            }}<span class="agree-css" @click="goToLogin"
              >{{ $t("clickHereGoTo") }}
            </span>
          </p>
        </div>
      </div>
    </div>
    <!-- 注册成功弹出层 -->
    <div class="login-dialog" v-if="registrationSuccess">
      <div class="dialog-main">
        <img src="./assets/Group 277.png" alt="" />
        <p>{{ $t("mailSentSuccessfully") }}</p>
        <button class="dialog-button" @click="reSuccessButton(1)">
          {{ $t("close") }}
        </button>
      </div>
    </div>
    <!-- 注册失败弹出层 -->
    <div class="login-dialog" v-if="registrationError">
      <div class="dialog-main">
        <img src="./assets/Group03.png" alt="" />
        <p>{{ $t("emailSendingFailed") }}</p>
        <button class="dialog-button1" @click="reSuccessButton(2)">
          {{ $t("close") }}
        </button>
      </div>
    </div>

    <!-- --------------------------弹窗dialog-------------------------- -->
    <div>
      <el-dialog :visible.sync="addDialogVisible">
        <div class="add-dialog-css">
          <!-- 左边 -->
          {{ $t("registrationAgreement") }}
          <!-- 确定按钮 -->
          <div class="insure">
            <button class="insure-button" @click="addDialogClose">
              {{ $t("confirm") }}
            </button>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { userRegister } from "../../js/api";

export default {
  name: "register",
  components: {},
  data() {
    return {
      userName: "", //用户名
      userNameShow: false,
      emilData: "", //emil数据
      emilShow: false,
      passWordData: "", //密码数据
      passWordShow: false,
      insurePassWordData: "", //确认密码数据
      insurePassWordShow: false,
      lang: "JP", //语言
      registrationSuccess: false, //注册成功标识
      registrationError: false, //注册失败标识
      type: 0,
      addDialogVisible: false
    };
  },
  created() {},
  computed: {},
  methods: {
    // input校验
    registerData(num) {
      var reg = /^[a-zA-Z0-9\w|\-\.]+@[a-zA-Z0-9\w|\-]+\.([a-zA-Z]{2,4}){1,32}$/;
      var password = /^(?=.*\d)(?=.*[a-zA-Z])[\da-zA-Z~!@#$%^&*]{6,18}$/;
      var userNameRule = /^.{1,32}$/;
      if (num === 1) {
        if (reg.test(this.emilData)) {
          this.emilShow = false;
        } else {
          this.emilShow = true;
        }
      } else if (num === 2) {
        if (password.test(this.passWordData)) {
          this.passWordShow = false;
        } else {
          this.passWordShow = true;
        }
      } else if (num === 3) {
        if (this.insurePassWordData !== this.passWordData) {
          this.insurePassWordShow = true;
        } else {
          this.insurePassWordShow = false;
        }
      } else if (num === 4) {
        if (userNameRule.test(this.userName)) {
          this.userNameShow = false;
        } else {
          this.userNameShow = true;
        }
      }
    },
    //弹窗消失
    reSuccessButton(num) {
      if (num === 1) {
        this.registrationSuccess = false;
      } else {
        this.registrationError = false;
      }
    },
    //语言转换
    handleCommand(command) {
      if (command === "0") {
        this.$i18n.locale = "zh-CN";
        this.lang = "CN";
      } else {
        this.$i18n.locale = "ja-JP";
        this.lang = "JP";
      }
    },
    // 去往登录页面
    goToLogin() {
      this.$router.push("/login");
    },
    // 详情dialog close
    addDialogClose() {
      this.addDialogVisible = false;
    },
    agree() {
      this.addDialogVisible = true;
    },
    toRegister(index) {
      if (
        this.userNameShow === false &&
        this.emilShow === false &&
        this.passWordShow === false &&
        this.insurePassWordShow === false
      ) {
        if (index === 1) {
          //医疗机构注册接口
          var fakeInfo = {
            emailAddress: this.emilData,
            institution: "medicalinstitution",
            language: this.lang,
            password: this.insurePassWordData,
            userName: this.userName
          };
          userRegister(fakeInfo)
            .then(res => {
              console.log("医疗机构注册接口数据:", res);
              if (res.data.code === "A0000") {
                this.registrationSuccess = true;
              } else if (res.data.code === "A0155") {
                this.registrationError = true;
              } else if (res.data.code === "A0160") {
                this.$message.error(this.$t("userMsg"));
              }
            })
            .catch(res => {
              console.log("医疗机构注册接口数据异常:", res);
            });
        } else if (index === 2) {
          //教育机构注册接口
          var fakeInfo = {
            emailAddress: this.emilData,
            institution: "educationalinstitution",
            language: this.lang,
            password: this.insurePassWordData,
            userName: this.userName
          };
          userRegister(fakeInfo)
            .then(res => {
              console.log("教育机构注册接口数据:", res);
              if (res.data.code === "A0000") {
                this.registrationSuccess = true;
              } else if (res.data.code === "A0155") {
                this.registrationError = true;
              } else if (res.data.code === "A0160") {
                this.$message.error("用户已认证");
              }
            })
            .catch(res => {
              console.log("教育机构注册接口数据异常:", res);
            });
        } else {
          this.$message.error(this.$t("changeMechanism"));
        }
      } else {
        this.$message.error(this.$t("errorMsg"));
      }
    },
    checkoutType(index) {
      if (index === 1 || index === 2) {
        this.type = index;
      } else {
        this.sort = index;
      }
    },

    //测试
    ceShi() {
      var fakeInfo = {
        emailAddress: "331140523@qq.com",
        institution: "medicalinstitution",
        language: "cn",
        password: "123456789",
        userName: "前端联调测试用户1"
      };
      userRegister(fakeInfo)
        .then(res => {
          console.log("注册接口数据:", res);
        })
        .catch(res => {
          console.log("注册接口数据:", res);
        });

      registerVerifyEmail()
        .then(res => {
          console.log("用户注册邮箱验证接口数据", res);
        })
        .catch(res => {
          console.log("用户注册邮箱验证接口数据:", res);
        });
    },
    // 返回主页面
    goToIndex() {
      console.log("回到主页面");
      this.$router.push("/");
    }
  }
};
</script>
<style scoped>
.emil-true-css {
  width: 100%;
  text-align: right;
  padding-right: 20px;
  box-sizing: border-box;
  display: inline-block;
  margin-left: 10px;
  color: #f56c6c;
}

.login {
  width: 100%;
  height: 100vh;
  background: #51abff;
  display: flex;
  min-height: 647px;
}

.login-dialog {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.6);
}

.dialog-main {
  width: 498px;
  height: 266px;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 12px 5px -10px rgba(0, 0, 0, 0.1), 0 0 4px 0 rgba(0, 0, 0, 0.1);
}

.dialog-main img {
  width: 66px;
  height: 66px;
  margin-bottom: 30px;
  margin-top: 37px;
}

.add-dialog-css {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.dialog-main p {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #686868;
}

.dialog-button {
  margin-top: 30px;
  width: 118px;
  height: 24px;
  line-height: 24px;
  background: #ffffff;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  cursor: pointer;
}

.dialog-button1 {
  margin-top: 30px;
  width: 118px;
  height: 24px;
  line-height: 24px;
  background: #ffffff;
  border: 1px solid #fc630c;
  box-sizing: border-box;
  border-radius: 4px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #fc630c;
  cursor: pointer;
}

.login-logo {
  height: 100vh;
  width: 56%;
  position: relative;
  /* padding: 250px 0 0 110px; */
  box-sizing: border-box;
  overflow: hidden;
}

.logo-title {
  font-family: "Mochiy Pop P One";
  font-style: normal;
  font-weight: 400;
  font-size: 78px;
  line-height: 139px;
  color: #ffffff;
  margin-top: -25px;
}

.logo-title-intro {
  width: 312px;
  height: 176px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 40px;
  color: #ffffff;
  margin-top: 36px;
}

.login-main {
  flex: 1;
  background: #ffffff;
  position: relative;
}
.logo-img {
  height: 400px;
  transform: translateX(10%);
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

.register {
  background: #ffffff;
  border: 2px solid #ececec;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 8px;
  width: 404px;
  height: 647px;
  position: absolute;
  /* top: 50%; */
  top: 0;
  bottom: 0;
  left: 50%;
  margin: auto;
}

.box-top {
  height: 50px;
  line-height: 50px;
  width: 100%;
}

.top-icon {
  width: 50px;
  height: 50px;
  float: right;
  text-align: center;
  cursor: pointer;
}

.box-bottom {
  /* height: 618px; */
  padding: 0 40px;
}

.bottom-box-title {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 324px;
  height: 56px;
}

.welcom {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  align-items: center;
  text-align: center;
  color: #98989e;
  margin: 3px 0px;
}

.ja-welcom {
  width: 100%;
  height: 32px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: #212429;
}

.welcom-dropdown {
  padding-top: 15px;
  box-sizing: border-box;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 13.6333px;
  line-height: 16px;
  letter-spacing: 0.639063px;
  color: #686868;
  margin-left: 5px;
}

.el-dropdown-link {
  cursor: pointer;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.box-form {
  margin-top: 20px;
}

.emil-input {
  padding: 0px;
  width: 324px;
  height: 66px;
  margin-bottom: 10px;
}

.emil-input-title {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #686868;
  margin: 8px 0px;
}

.emil-input-css {
  border: 1px solid #d8d8d8;
  box-sizing: border-box;
  border-radius: 24px;
  height: 40px;
  width: 320px;
  box-sizing: border-box;
}

.emil-icon {
  margin-right: 10px;
  margin-left: 15px;
}

.emil-input-css-main {
  width: 250px;
  height: 38px;
  line-height: 38px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  color: #c9cfda;
}

.two-button {
  margin-top: 8px;
  border-radius: 24px;
  width: 150px;
  height: 40px;
}

.two-button button {
  border: 1px solid #d8d8d8;
  box-sizing: border-box;
  border-radius: 24px;
  width: 150px;
  height: 40px;
  background: #fff;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  letter-spacing: -0.02em;
  color: #686868;
  margin-right: 8px;
}

.button-margin {
  margin: 0;
}

.agree {
  margin-top: 30px;
  text-align: center;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  align-items: center;
  letter-spacing: -0.02em;
  color: #c9cfda;
}

.agree-css {
  cursor: pointer;
  color: #51abff;
  margin-right: 5px;
}

.insure {
  height: 50px;
  margin-top: 13px;
  margin-bottom: 10px;
}

.insure-button {
  background: #fc630c;
  border-radius: 24px;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 23px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #ffffff;
  width: 320px;
  cursor: pointer;
  height: 50px;
}

.agree1 {
  margin-top: 15px;
}

.typeActive button {
  border: 1px solid #d8d8d8;
  box-sizing: border-box;
  border-radius: 24px;
  width: 150px;
  height: 40px;
  background: #51abff;
  color: #fff;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  letter-spacing: -0.02em;
  color: #686868;
  margin-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/pages/register/index.vue